import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CardMedia,
  Container,
  Grid,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

const eventsData = [
  {
    id: 1,
    image: "./images/event1.webp",
    title: "Jallikattu Bull Festival",
    date: "Jan 16, 2023",
    location: "Madurai",
    category: "Tamilnadu Tourism",
  },
  {
    id: 2,
    image: "./images/event2.webp",
    title: "Pongal Festival",
    date: "Jan 15, 2023",
    location: "Madurai",
    category: "Tamilnadu Tourism",
  },
  {
    id: 3,
    image: "./images/event3.webp",
    title: "Indian Dance Festival",
    date: "Dec 22, 2023",
    location: "Mamallapuram",
    category: "Tamilnadu Tourism",
  },
  {
    id: 4,
    image: "./images/event4.webp",
    title: "Music & Dance Festival",
    date: "Dec 25, 2024",
    location: "Chennai",
    category: "Tamilnadu Tourism",
  },
];

const ActivitiesEvents = () => {
  return (
    <Box
      id="activities-events"
      sx={{ background: "black", color: "white", py: 5 }}
    >
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Typography variant="h4" align="center" gutterBottom>
              Activities & Events
            </Typography>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={false}
              pagination={false}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {eventsData.map((event) => (
                <SwiperSlide key={event.id}>
                  <Card style={{ margin: "10px auto" }}>
                    <CardMedia
                      component="img"
                      height="140"
                      image={event.image}
                      alt={event.title}
                    />
                    <CardContent>
                      <Box display="flex" alignItems="center" gap={1}>
                        <EventIcon color="primary" />
                        <Typography variant="h6">{event.title}</Typography>
                      </Box>
                      <Typography color="textSecondary">
                        {event.date} - {event.location}
                      </Typography>
                      <Typography variant="body2">
                        Category: {event.category}
                      </Typography>
                    </CardContent>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ActivitiesEvents;
